import { Modal } from "../../../../components";
import { useAdminStore } from "../../../../store/adminStore";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { motion } from "framer-motion";
import ViewMap from "../../../../components/ViewMap";
import { useEffect, useState } from "react";
import { Alert, Badge, Button } from "react-bootstrap";
import { handlerCambiarEstado, handlerCancelar } from "../../../../handlers/actas.handler";
import StarDisplay from "../../../../components/StarDisplay";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import Loading from "../../../../components/Loading";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useInspectorStore } from "../../../../store/inspectorStore";
import ArrowUp from "../../../../components/svgs/ArrowUp";
import ArrowDown from "../../../../components/svgs/ArrowDown";

const ModalActaInspector = () => {
  const size = useWindowSize();
  const { width } = size;

  const { modals, handlerModal, loads } = useGeneralAppStore();
  const [verConstatacion, setVerConstatacion] = useState(false);

  const { acta, setActa } = useInspectorStore();

  const [imgSelect, setImgSelect] = useState(acta?.archivos[0]?.base64?.file || null);
  const [previews, setPreviews] = useState([]);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [zoomStyle, setZoomStyle] = useState({});

  const handleMouseMove = (e) => {
    const { offsetX, offsetY, target } = e.nativeEvent;
    const { width, height } = target;

    // Calculamos las posiciones relativas dentro de la imagen
    const xPos = (offsetX / width) * 100;
    const yPos = (offsetY / height) * 100;

    // Aplicamos un zoom y ajustamos la posición
    setZoomStyle({
      transform: `scale(1.5)`,
      transformOrigin: `${xPos}% ${yPos}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({
      transform: "scale(1)",
    });
  };

  useEffect(() => {
    if (previews.length > 0) {
      setImagePreviewUrl(previews[0]);
    }
  }, [previews]);

  useEffect(() => {
    if (acta?.archivos) {
      const basesPreviews = acta?.archivos.map((img) => {
        return img.base64.file;
      });
      setPreviews(basesPreviews);
    }
  }, []);

  useEffect(() => {
    return () => {
      setActa(null);
      handlerModal({ modal: false, modalName: "modal_solicitud_inspector" });
    };
  }, []);

  return (
    <>
      <Modal
        // fullscreen={true}
        size="lg"
        show={modals.includes("modal_solicitud_inspector")}
        onHide={() => handlerModal({ modal: false, modalName: "modal_solicitud_inspector" })}
        title={() => "Detalle del acta"}
      >
        <motion.div
          key="form"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="w-100 position-relative "
        >
          {loads.includes("cambiar_estado") && (
            <div
              className="w-100 h-100 position-absolute d-flex justify-content-center align-items-center"
              style={{ backgroundColor: "rgba(255,255,255,0.8)", zIndex: "99999" }}
            >
              <Loading sizeLoad="70px" sizeIcono="50px" font="16px" />
            </div>
          )}

          <div>
            <div className="d-flex justify-content-end mb-2 gap-2">
              <span>Fecha:</span> <span className="fw-bold text-dark">{acta?.fecha_solicitud}</span>
            </div>
            {acta?.estado_id == 5 && (
              <Alert
                variant="primary"
                className={`d-flex gap-3 align-items-center ${width >= 992 ? "" : "flex-column"}`}
              >
                <div>
                  Se necesita subir el <b>acta de constatación</b>, para poder aceptar la solicitud
                </div>
                <Button
                  size="sm"
                  onClick={() => handlerModal({ modal: true, modalName: "modal_constatacion" })}
                >
                  Subir constatación
                </Button>
              </Alert>
            )}
            {acta?.estado_id == "3" && (
              <Alert variant="danger">
                El acta fue <b>cancelada</b>
              </Alert>
            )}
            {(acta?.estado_id == 10 || acta?.estado_id == 2 || acta?.estado_id == 8) && (
              <>
                <Alert variant="success" className="d-flex gap-3 align-items-center">
                  <div>
                    La solicitud esta en estado <b>{acta?.estado?.estado}</b>
                  </div>
                  {/* <Button size="sm" onClick={() => handlerModal({ modal: true, modalName: "modal_constatacion" })}>Subir constatación</Button> */}
                </Alert>
                <div>
                  <div>
                    <p
                      onClick={() => {
                        setVerConstatacion(!verConstatacion);
                      }}
                      style={{ cursor: "pointer" }}
                      className="m-0 bg-primary w-100 px-4 py-2 text-white d-flex justify-content-between"
                    >
                      Detalle de la constatación
                      {verConstatacion ? <ArrowUp color="#fff" /> : <ArrowDown color="#fff" />}
                    </p>
                  </div>
                  <motion.div
                    initial={{ minHeight: 0, opacity: 0 }}
                    animate={{
                      minHeight: !verConstatacion ? 0 : "auto",
                      opacity: verConstatacion ? 1 : 0,
                    }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className={`${
                      verConstatacion && "p-3"
                    } d-flex  mx-auto d-flex mb-1 border border-1 border-[#AAA] rounded-b-xl border-t-0`}
                    style={{ width: "100%" }}
                  >
                    {verConstatacion && (
                      <section className={` w-100 d-flex ${width < 992 && "flex-column"}`}>
                        <div
                          className={`${
                            width >= 992 ? "col-6" : "col-12"
                          } d-flex flex-column gap-4`}
                        >
                          <div>
                            <h5 className="text-dark mb-0">Datos de la constatación</h5>
                            <hr className="mb-3 mt-1 text-dark" />

                            <p className="m-0 text-primary fw-bold ">
                              Número de acta:{" "}
                              <span className="fw-medium text-dark">
                                {acta?.constatacion?.numero_acta}
                              </span>
                            </p>
                          </div>
                          <p className="m-0 text-primary fw-bold d-flex flex-column">
                            Observacion:{" "}
                            <span className="fw-medium text-dark">
                              {acta?.constatacion?.observacion}
                            </span>
                          </p>
                          <p className="m-0 text-primary fw-bold d-flex flex-column">
                            Constatacion de daños:{" "}
                            <span className="fw-medium text-dark">
                              {acta?.constatacion?.constatacion_dano}
                            </span>
                          </p>
                          <p className="m-0 text-primary fw-bold d-flex flex-column">
                            Descripción tarea:{" "}
                            <span className="fw-medium text-dark">
                              {acta?.constatacion?.descripcion_tarea}
                            </span>
                          </p>
                        </div>
                        {width < 992 && <hr />}
                        <div>
                          {width < 992 && (
                            <p className="m-0 text-primary fw-bold d-flex flex-column">
                              Acta de constatacion:
                            </p>
                          )}
                          <div
                            className={`${
                              width >= 992 ? "col-6" : "col-12"
                            } d-flex flex-column w-100`}
                            style={{ background: "#28252A" }}
                          >
                            <img
                              src={acta?.constatacion?.constatacion_file?.base64?.file}
                              alt="img-constatacion"
                              className="w-100 object-fit-contain"
                              style={{ aspectRatio: "3/4" }}
                            />
                          </div>
                        </div>
                      </section>
                    )}
                  </motion.div>
                </div>
              </>
            )}
          </div>
          <hr />
          <div
            className={`d-flex gap-4   justify-content-center mt-2 ${
              width >= 640 ? "px-4 col-12 " : "px-0 col-12 flex-wrap"
            }  mx-auto justify-content-between`}
            // style={{ minHeight: "300px" }}
          >
            <section
              className={` d-flex   ${width >= 992 ? "col-12" : "flex-column col-12 gap-3"}`}
            >
              <div className={`${width >= 992 ? "col-6" : "col-12"}`}>
                <h5 className="text-dark">Datos personles</h5>
                <p className="m-0 text-primary fw-bold">
                  Nombre: <span className="fw-medium text-dark">{acta?.nombre_ciudadano}</span>
                </p>
                <p className="m-0 text-primary fw-bold">
                  Documento: <span className="fw-medium text-dark">{acta?.dni}</span>
                </p>
                <p className="m-0 text-primary fw-bold">
                  Teléfono: <span className="fw-medium text-dark">{acta?.telefono}</span>
                </p>
                <p className="m-0 text-primary fw-bold">
                  Email: <span className="fw-medium text-dark">{acta?.email}</span>
                </p>
                <p className="m-0 text-primary fw-bold">
                  {/* Barrio: <span className="fw-medium text-dark">{acta?.barrio?.nombre}</span> */}
                  Barrio: <span className="fw-medium text-dark">{acta?.barrio}</span>
                </p>
                <p className="m-0 text-primary fw-bold">
                  Domicilio: <span className="fw-medium text-dark">{acta?.domicilio}</span>
                </p>
              </div>
              <div className={`${width >= 992 ? "col-6" : "col-12"}`}>
                <h5 className="text-dark">Datos de la solicitud</h5>
                {/* <div className="d-flex gap-2 flwx-wrap"> */}
                <div className=" d-flex gap-2">
                  <p className="m-0 text-primary fw-bold">Lugar: </p>
                  <span className="fw-medium text-dark">{acta?.lugar}</span>
                </div>
                <div className=" d-flex gap-2">
                  <p className="m-0 text-primary fw-bold">Tipo solicitante: </p>
                  <span className="fw-medium text-dark">{acta?.tipo_persona_solicitante}</span>
                </div>
                <div className=" d-flex gap-2">
                  <p className="m-0 text-primary fw-bold">Nombre solicitante: </p>
                  <span className="fw-medium text-dark" style={{ wordBreak: "break-word" }}>
                    {acta?.solicitante}
                  </span>
                </div>
                <div className="d-flex flex-column ">
                  <p className="m-0 text-primary fw-bold">Tipo de solicitud: </p>
                  <ul>
                    {acta?.tipos_solicitud.map((solicitud, index) => {
                      return (
                        <li key={index}>
                          {`${solicitud.nombre} | cant. arboles: ${solicitud.cantidad_arboles}`}{" "}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="d-flex gap-2">
                  <p className="m-0 text-primary fw-bold ">Descripción: </p>
                  <span className="fw-medium text-dark">{acta?.descripcion}</span>
                </div>
                {/* </div> */}
              </div>
              {/* <button className='col-2 btn btn-success btn-sm ' type='submit' style={{width:"fit-content"}}>Siguiente</button> */}
            </section>
          </div>
          <hr />
          {/* <section className={`d-flex gap-4 mt-3  mx-auto align-items-start ${width >= 992 ? "px-3 col-12 " : "flex-wrap col-12 px-0 pb-4"}`}> */}
          <section
            className={`d-flex  gap-4 ${
              width > 992 ? "mt-3 px-3 col-11" : "flex-wrap "
            }   mx-auto align-items-start`}
          >
            {acta?.latitud && acta?.longitud && (
              <div className={`${width > 992 ? "col-6" : "col-12"}`}>
                {/* <div className={`${width >= 992 ? "col-6" : "col-12"}`}> */}
                <h5>Ubicación</h5>
                <div
                  className="w-100"
                  // style={{ height: width >= 992 ? "310px" : "200px", border: "2px solid #1134C9" }}
                  style={{ height: width > 992 ? "320px" : "200px", border: "2px solid #1134C9" }}
                >
                  {acta && <ViewMap center={[acta?.latitud, acta?.longitud]} />}
                </div>
              </div>
            )}
            {acta?.archivos?.length > 0 && (
              <section
                className={`col  d-flex ${
                  width <= 992 ? "flex-column-reverse" : "justify-content-center"
                } `}
              >
                <div
                  className={` border border-2 rounded d-flex    gap-3 justify-content-start p-2 ${
                    width <= 992 ? "overflow-x-scroll w-100" : "overflow-y-scroll flex-column"
                  } `}
                  style={{ width: "75px", aspectRatio: width <= 992 ? "" : "3/4" }}
                >
                  {previews.map((imagen, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          aspectRatio: width <= 992 ? "3/4" : "9/16",
                          border:
                            imagePreviewUrl == imagen ? "2px solid #1134C9" : "2px solid #c9c9c9",
                          cursor: "pointer",
                          overflow: "hidden",
                          height: width <= 992 && "20px",
                          minHeight: "55px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className=" d-flex flex-column justify-content-center align-items-center"
                        onClick={() => {
                          setImagePreviewUrl(imagen);
                        }}
                      >
                        <img
                          key={index}
                          src={imagen}
                          alt="img-prev"
                          style={{
                            cursor: "pointer",
                            objectFit: "contain",
                            backgroundColor: "#c9c9c9",
                            height: "100%",
                            width: "100%",
                          }}
                          onClick={() => {
                            setImagePreviewUrl(imagen);
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                <div
                  className=""
                  style={{
                    overflow: "hidden",
                    aspectRatio: "3/4",
                    height: width <= 992 ? "390px" : "350px",
                    backgroundColor: "#28252A",
                  }}
                >
                  {imagePreviewUrl && (
                    <img
                      src={imagePreviewUrl}
                      alt="img-select"
                      className="w-100 h-100 zoom-image"
                      style={{ ...zoomStyle, objectFit: "contain" }}
                      onMouseMove={handleMouseMove}
                      onMouseLeave={handleMouseLeave}
                    />
                  )}
                </div>
              </section>
            )}
          </section>
          {![3, 8, 2].some((estado) => estado == acta?.estado?.id) && (
            <Alert
              variant="danger"
              className="m-0 d-flex flex-column align-items-center gap-2 mt-5"
            >
              Si desea rechazar la solicitud, haga click en "Rechazar".
              <Button
                variant="danger"
                size="sm"
                onClick={() => handlerModal({ modal: true, modalName: "cancelar_acta" })}
              >
                Rechazar
              </Button>
            </Alert>
          )}
        </motion.div>
      </Modal>
    </>
  );
};
export default ModalActaInspector;
